module.exports = __webpack_public_path__ + "static/media/faq.74d9ec37.svg";